
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { userUpdate, userPassUpdate } from '@/api'
import { useToast } from 'vue-toastification'
import { UserInfo } from '@/store/index'
import bus from '@/plugins/bus'
import Button from '@/components/btn.vue'
interface User extends UserInfo {
  name?: string;
  email?: string;
  description?: string;
  password?: string;
}
export interface PasswordForm {
  oldpass: string;
  newpass: string;
  passwordConfirm: string;
}
export default defineComponent({
  components: {
    Button
  },
  setup () {
    const store = useStore()
    const toast = useToast()
    const name = ref('')
    const email = ref('')
    const description = ref('')
    const password = ref('')
    const passwordConfirm = ref('')
    const oldPass = ref('')
    const updateUserInfo = async () => {
      const removeEmpty = (obj: User) => {
        return Object.fromEntries(Object.entries(obj).filter((key) => key[1]))
      }
      const infoObj: User = {
        name: name.value,
        email: email.value,
        description: description.value
      }
      const finalObj: User = removeEmpty(infoObj)
      try {
        toast.info('Updating new info')
        const res = await userUpdate(finalObj)
        if (res.status === 200) {
          store.dispatch('setUser', res.data.data.user)
          toast.success('Info updated')
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const passwordUpdate = async () => {
      try {
        const updateInfo: PasswordForm = {
          oldpass: oldPass.value,
          newpass: password.value,
          passwordConfirm: passwordConfirm.value
        }
        const res = await userPassUpdate(updateInfo)
        if (res.status === 200) {
          toast.success('Password changed')
          password.value = ''
          passwordConfirm.value = ''
          oldPass.value = ''
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const cropperOpen = () => {
      bus.emit('Cropper-open')
    }
    const user = computed(() => {
      return store.getters.getUser
    })
    return {
      user,
      passwordUpdate,
      name,
      email,
      description,
      password,
      passwordConfirm,
      updateUserInfo,
      oldPass,
      cropperOpen
    }
  }
})
